<div class="nav-link-content">
  <ng-content></ng-content>
</div>
